import styled from 'styled-components';
import HotelCancelledSvg from '../../assets/mytrips/hotel-cancelled.svg';

const HotelCancelledIcon = styled(HotelCancelledSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.5rem'};
  height: ${props => props.height || '2.5rem'};
  margin: ${props => props.margin};
`;

export default HotelCancelledIcon;
